// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.jpg";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import bubbleio from "./assets/techstack/bubbleio1.png";
import bubbleio1 from "./assets/techstack/bubbleio.png";
import bubbleio2 from "./assets/techstack/bubbleio_icon.png";
import digitalocean from "./assets/techstack/digitalocean.png";
import laravel from "./assets/techstack/laravel-logo.png";
import php from "./assets/techstack/php2.png";
import wordpress from "./assets/techstack/wp-logo.png";
import n8n from "./assets/techstack/n8n_new.svg";

// Porject Images
import projectImage1 from "./assets/projects/lightdashboard.jpg";
import projectImage2 from "./assets/projects/nftmarketplace.jpg";
import projectImage3 from "./assets/projects/simple_user_management.jpg";
import projectImage4 from "./assets/projects/mairmair.PNG";
import projectImage5 from "./assets/projects/bestwatch.PNG";
import projectImage51 from "./assets/projects/robofi1.png"
import projectImage6 from "./assets/projects/finapac.PNG";
import projectImage7 from "./assets/projects/snapinnovation.PNG";
import projectImage8 from "./assets/projects/gamesplatform.PNG";
import projectImage9 from "./assets/projects/thbss.PNG";
import projectImage10 from "./assets/projects/scholarshipguidesg.PNG";
import projectImage11 from "./assets/projects/hardcopynew.png";
import projectImage14 from "./assets/projects/swotai.png";
import projectImage15 from "./assets/projects/smartnew88.png";
import projectImage16 from "./assets/projects/nhai.png";
import projectImage17 from "./assets/projects/golf.png";
import projectImage18 from "./assets/projects/property.png";
import projectImage19 from "./assets/projects/uplinked.png";
import projectImage20 from "./assets/projects/trucking88.png";

import projectImage21 from "./assets/projects/agentdesk_banner1.jpg"
import projectImage22 from "./assets/projects/smarthirebanner.jpg"
import projectImage25 from "./assets/projects/the-cherokee-group.png"

import projectImage26 from "./assets/projects/leadflowbanner.jpg"

import projectImage27 from "./assets/projects/marketingscience.png"


import projectImage28 from "./assets/projects/knowledge_flow_banner.jpg"

import projectImage29 from "./assets/screenshots/dailyjirasummarizer/ss1.png";

import projectImage30 from "./assets/projects/dailybusinessreportbanner.png";
import projectImage31 from "./assets/projects/doc_translation_banner.png";
import projectImage32 from "./assets/projects/customeranalysisbanner.png";
import projectImage33 from "./assets/projects/inventorymanagement.png";
import projectImage34 from "./assets/projects/dailyticketsummaries.png";
import projectImage35 from "./assets/projects/jiraticketcreation.png";
import projectImage36 from "./assets/projects/productaienrichment.png";
import projectImage37 from "./assets/projects/proposalautomation.png";


// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Billy Christi",
  tagline: "I build things for web",
  img: profile,
  // about: `I am an AI Automation Specialist (n8n) focused on building intelligent, automated workflows that help businesses operate more efficiently and scale faster. I have successfully built and delivered multiple AI automation projects using n8n for clients across different industries, integrating advanced AI capabilities into their operations.`,
  // about1: `In addition to my automation expertise, I am a certified Bubble.io developer with over 5 years of professional experience in software engineering. I have developed and delivered more than 10 Bubble.io projects for clients in multiple countries. My technical skill set also includes PHP, JavaScript, React, Laravel, and other modern technologies, enabling me to create robust, scalable web applications and custom automation solutions tailored to diverse business needs.`

   about: `I am a certified Bubble.io developer with over 5 years of professional experience in software engineering. I have successfully developed and delivered more than 10 Bubble.io projects for clients across multiple countries. My expertise extends beyond Bubble.io, including technologies like PHP, JavaScript, React, Laravel, and more. This allows me to build robust and scalable web applications tailored to diverse business needs.`,
  about1: `With a solid foundation in software engineering, I also specialize in AI automation using n8n. I have helped businesses across various industries streamline their operations and scale faster by creating intelligent, automated workflows that integrate advanced AI capabilities into their processes.`
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "http://google.com/",
  github: "http://google.com/",
  youtube: "http://google.com/"
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "AI Automation Specialist (n8n)",
    Company: "Independent",
    Location: "Remote",
    Type: "Part-Time",
    Duration: "January 2025 - Present",
    Link: "https://www.billychristi.com/"
  },
  {
    Position: "Senior Bubble.io Developer",
    Company: `NerdHeadz - Gold Tier Bubble.io Agency`,
    Location: "United States",
    Type: "Part-Time",
    Duration: "July 2023 - Present",
    Link: "https://www.nerdheadz.com/"
  },
  {
    Position: "Software Engineer",
    Company: `CSG International`,
    Location: "United States",
    Type: "Full-Time",
    Duration: "March 2022 - June 2023",
    Link: "https://www.csgi.com/"
  },
  {
    Position: "Software Engineer",
    Company: `Snap Innovations Pte Ltd`,
    Location: "Indonesia",
    Type: "Full-Time",
    Duration: "May 2020 - Feb 2022",
    Link: "https://snapinnovations.com/"
  },
  {
    Position: "Mobile Developer",
    Company: `Astra Graphia Information Technology`,
    Location: "Jakarta, Indonesia",
    Type: "Full-Time",
    Duration: "Oct 2018 - Sep 2019",
    Link: "https://www.ag-it.com/"
  },
  {
    Position: "Software Engineer",
    Company: `Mitrais`,
    Location: "Jakarta, Indonesia",
    Type: "Full-Time",
    Duration: "Aug 2017 - Sep 2018",
    Link: "https://mitrais.com/"
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Bachelor's degree in Business Information Systems",
    Company: "Petra Christian University",
    Location: "Indonesia",
    Type: "Full Time",
    Duration: "2013 - 2017",
    Link: "https://en.wikipedia.org/wiki/Petra_Christian_University"
  }
];

// Tech Stack and Tools
export const techStackDetails = {
  n8n: n8n,
  bubbleio: bubbleio1,
  wordpress: wordpress,
  digitalocean: digitalocean,
  laravel: laravel,
  php: php,
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
};

// Enter your Project Details here
export const projectDetails = [
  // {
  //   title: "Smart SETC",
  //   image: projectImage15,
  //   description: `Developed a user-friendly website for determining eligibility for up to $32,220 in SETC relief funds. The site features a straightforward, question-based interface to assess qualifications, enhancing accessibility for self-employed individuals. This project showcases my ability to create efficient, user-centric solutions.`,
  //   techstack: "Bubble.io, Docusign, Javascript, TaxStatus, Stripe, API Connector",
  //   previewLink: "https://portal.smartsetc.com/",
  //   githubLink: "https://github.com",
  // },
  {
    title: "Marketing Science Today",
    image: projectImage27,
    description: `Marketing Science Today helps marketers make smarter investment decisions by putting all the tools, insights, and expert guidance they need in one place. With so many analytics solutions and constant changes in the industry, it can be overwhelming to know what works and who to trust. This platform was created to cut through the noise, giving marketers a space to learn, ask questions freely, and stay up to date without pressure from sales-driven vendors.`,
    techstack: "Bubble.io, Stripe, API Connector",
    previewLink: "https://marketingscience.today/",
    githubLink: "https://github.com",
  },
  {
    title: "NerdHeadz AI",
    image: projectImage16,
    description: `Nerdheadz AI – A project estimation platform built with Bubble.io and integrated with ChatGPT AI for fast, accurate estimates in just 5 minutes. Featuring a messaging system to gather user requirements, it generates detailed feature lists and outputs results in a professional PDF format using a custom-built PHP PDF generator.`,
    techstack: "Bubble.io, OpenAI API, Javascript, PHP, API Connector",
    previewLink: "https://estimate.nerdheadz.com/",
    githubLink: "https://github.com",
  },
  
  {
    title: "JLS Golf Club",
    image: projectImage17,
    description: `Effortless online booking and tee time management solution for golf courses in Indonesia. Built with Bubble.io, this user-friendly system enhances the customer experience with intuitive interfaces, ensuring seamless booking and increased player retention.`,
    techstack: "Bubble.io",
    previewLink: "https://jls.golf/",
    githubLink: "https://github.com",
  },
  {
    title: "Property Auction",
    image: projectImage18,
    description: `A specialized platform for searching commercial and residential real estate auctions. Built with Bubble.io, it offers a streamlined experience, displaying only relevant live and online real estate auctions to save users time and simplify property discovery.`,
    techstack: "Bubble.io, Javascript",
    previewLink: "https://propertyauction.com/",
    githubLink: "https://github.com",
  },
  {
    title: "Hardcopy.io",
    image: projectImage11,
    description: `Centrally store your important documents in the Hardcopy Cloud. No more using ad hoc systems, or even paper-based methods! With the Hardcopy platform you and your team can securely file your docs and search with ease.`,
    techstack: "Bubble.io, PHP, JS, MySQL, HTML/CSS",
    previewLink: "https://hardcopy.io/",
    githubLink: "https://github.com",
  },
  {
    title: "UpLinked",
    image: projectImage19,
    description: `A LinkedIn post scheduling and strategy management platform integrated with Stripe for seamless payments. Built with Bubble.io, it helps users plan, generate, and launch effective LinkedIn strategies with ease.`,
    techstack: "Bubble.io, Linkedin API, OpenAI API, Stripe API, Javascript",
    previewLink: "https://my.uplinked.app/start?login=yes",
    githubLink: "https://github.com",
  },
  {
    title: "Trucking88",
    image: projectImage20,
    description: `Trucking88 - A comprehensive TMS platform built with Bubble.io, tailored for small and medium-sized trucking companies. Designed to streamline operations, optimize routes, and enhance efficiency for smarter, more profitable fleet management.`,
    techstack: "Bubble.io, Javascript",
    previewLink: "https://app.trucking88.com/",
    githubLink: "https://github.com",
  },
 
  {
    title: "Scholarship Guide Singapore",
    image: projectImage10,
    description: `Scholarship Guide Singapore is a comprehensive platform offering detailed information on scholarships available in Singapore. Students can easily apply for various scholarships directly through the website, while advertisers can post their scholarship opportunities to reach a wider audience.`,
    techstack: "PHP, JS, Yii, MySQL, HTML/CSS",
    previewLink: "http://scholarshipguide.com.sg/",
    githubLink: "https://github.com",
  },
  {
    title: "mair-mair.com",
    image: projectImage4,
    description: `Developed an Italian Wine E-Commerce platform that seamlessly connects wine enthusiasts with a curated selection of authentic Italian wines. This project highlights my expertise in e-commerce solutions, user experience design, and the integration of secure payment systems.`,
    techstack: "PHP, MySQL, HTML, CSS, Bootstrap",
    previewLink: "https://mair-mair.com",
    githubLink: "https://github.com",
  },
  {
    title: "Light Dashboard",
    image: projectImage1,
    description: `Light Dashboard is a clean & responsive dashboard using white color palette as the base color, main features include table templates, form templates, graphs, user accounts, profiles, responsive sidebar`,
    techstack: "Bubble.io",
    previewLink: "https://light-dashboard.bubbleapps.io",
    githubLink: "https://github.com",
  },
  {
    title: "Simple User Management",
    image: projectImage3,
    description: `Simple User Management is the most simple user management dashboard for Bubble`,
    techstack: "Bubble.io",
    previewLink: "https://simple-user-management.bubbleapps.io/",
    githubLink: "https://github.com",
  },
  
  {
    title: "Inventory Management System",
    image: projectImage33,
    description: `Inventory Management System built with Bubble.io that helps businesses track, organize, and manage products, stock levels, sales, and purchases in one place. Provides a user-friendly dashboard and full CRUD functionality to simplify inventory tracking and daily operations.`,
    techstack: "Bubble.io",
    previewLink: "https://bubble.io/template/inventory-management-1695906875409x656904519732428800",
    githubLink: "https://github.com",
  },
  {
    title: "Robofi.io",
    image: projectImage51,
    description: `I handled the server setup, WordPress development, custom template customization, and created a custom plugin using PHP for RoboFi, a secure and transparent decentralized finance (DeFi) platform. RoboFi offers DAO-based crypto trading bots through an Initial Bot Offering (IBO).`,
    techstack: "WordPress, Custom Plugin Development, PHP, JavaScript, HTML/CSS",
    previewLink: "https://robofi.io/",
    githubLink: "https://github.com",
  },
  {
    title: "Finapac.sg",
    image: projectImage6,
    description: `I managed the server setup and WordPress development for Finapac Capital, a prominent fund management company registered with the Monetary Authority of Singapore and an esteemed member of the Singapore Fintech Association. My role encompassed ensuring a seamless and secure online presence for the company, aligning with industry standards and regulations.`,
    techstack: "WordPress, HTML/CSS",
    previewLink: "https://finapac.sg/",
    githubLink: "https://github.com",
  },
  {
    title: "SnapInnovations.com",
    image: projectImage7,
    description: `I set up the server and developed the WordPress site for Snap Innovations Pte Ltd, a company specializing in Artificial Intelligence, Blockchain, Financial Trading, and Technology Solutions. The goal was to create a reliable and user-friendly platform to highlight their innovative offerings.`,
    techstack: "WordPress, HTML/CSS",
    previewLink: "https://snapinnovations.com/",
    githubLink: "https://github.com",
  }
];

// Enter your Project Details here
export const n8nProjectDetails = [
   {
  title: "Automated Business Reporting System",
  image: projectImage30,
  description: "Automated Business Reporting System is an automation built with n8n that collects finance, sales, and operations data from Airtable, generates structured business reports, and automatically sends them to department heads and the CEO through Microsoft Outlook and Slack. It also triggers alerts when important conditions occur, eliminating manual reporting and ensuring leaders receive timely insights.",
  techstack: "n8n, Airtable, OpenAI GPT, Microsoft Outlook, Slack",
  previewLink: "/n8n/business-report-automation",
  githubLink: "https://github.com",
  id: "business-report-automation"
},
 {
  title: "Customer Feedback AI Analysis System",
  image: projectImage32,
  description: "Customer Feedback AI Analysis System is an AI-powered automation that collects customer feedback from Jotform, stores it in Airtable, and analyzes it using an AI LLM chain. The system automatically determines the sentiment of each feedback and sends notifications through email and Slack. Negative feedback is escalated to an urgent Slack channel, while positive feedback is shared with the team, allowing businesses to quickly respond to issues and make better decisions based on customer insights.",
  techstack: "n8n, Jotform, Airtable, OpenAI GPT, Slack, Email",
  previewLink: "/n8n/customer-feedback-ai-analysis-system",
githubLink: "https://github.com",
  id: "customer-feedback-ai-analysis-system"
},
{
    title: "AI-Powered PDF Invoice Parser for The Cherokee Group",
    image: projectImage25,
    description: `The Cherokee Group, a leading mechanical and electrical contractor providing plumbing, HVAC, and electrical services to residential and commercial clients, needed a reliable and intelligent way to process daily invoices received via email. With hundreds of invoices coming in every week, manually extracting data was time-consuming and error-prone. To solve this, we developed an AI-powered PDF invoice parser that automatically extracts and structures invoice data from email attachments every morning, allowing their finance team to stay accurate and efficient.`,
    techstack: "n8n, Microsoft Outlook, Microsoft OneDrive, OpenAI GPT, Gemini",
    previewLink: "/n8n/ai-pdf-invoice-parser",
    githubLink: "https://github.com",
    id: "ai-pdf-invoice-parser"
    
  },
  {
  title: "Document Translation Automation",
  image: projectImage31,
  description: "An automated workflow built with n8n that translates Google Docs from a source language to a target language, organizes the translated documents, converts them to PDF, and sends the results via email. The system automatically scans a Google Drive folder for new documents, processes them using AI translation, and manages the final outputs for easy distribution.",
  techstack: "n8n, Google Docs, Google Drive, OpenAI GPT",
  previewLink: "/n8n/document-translation-automation",
  githubLink: "https://github.com",
  id: "document-translation-automation"
},
{
  title: "AI Product Data Enrichment Automation",
  image: projectImage36,
  description: "AI Product Data Enrichment Automation is an AI-powered workflow that enriches product data by generating SEO titles, descriptions, bullet points, keywords, benefits, and other marketing content from existing product information. The system reads product records from Airtable, processes them using an AI LLM chain, and automatically updates the enriched data back into Airtable.",
  techstack: "n8n, Airtable, OpenAI GPT, n8n Forms",
  previewLink: "/n8n/ai-product-data-enrichment-automation",
  githubLink: "https://github.com",
  id: "ai-product-data-enrichment-automation"
},
{
  title: "AI Proposal Automation System",
  image: projectImage37,
  description: "AI Proposal Automation System automatically generates professional proposals from user-submitted form data. Using n8n, Jotform, Google Docs, Google Drive, Airtable, and OpenAI, the system collects proposal details, generates structured proposal content with AI, creates a formatted Google Docs proposal, converts it into a PDF, and stores all data and files in Airtable and Google Drive. The result is a fully automated workflow that transforms a simple form submission into a complete proposal document without manual work.",
  techstack: "n8n, Jotform, Google Docs, Google Drive, OpenAI GPT, Airtable",
  previewLink: "/n8n/ai-proposal-automation-system",
  githubLink: "https://github.com",
  id: "ai-proposal-automation-system"
},
 
  {
    title: "AgentDesk",
    image: projectImage21,
    description: `AgentDesk is an AI-powered customer support automation platform that streamlines ticket handling, agent assignment, and knowledge management. Built using n8n, Supabase, Airtable, and Bubble.io, it features AI agents for answering customer inquiries, escalating tickets, and intelligently routing them to the appropriate agents. It integrates with Gmail, Slack, and Airtable to automate communication and data storage. Human agents and admins manage tickets and knowledge through a dedicated web app that includes a ticket management system and a knowledge management system.`,
    techstack: "n8n, Supabase, Airtable, Bubble.io, OpenAI GPT, Slack, Gmail",
    previewLink: "/n8n/agentdesk",
    githubLink: "https://github.com",
    id: "agentdesk"
    
  },
   
  {
    title: "SmartHire",
    image: projectImage22,
    description: `SmartHire is an intelligent, fully automated recruitment and talent management platform designed to help companies streamline their hiring process and manage employee data effortlessly. Leveraging the power of n8n, Bubble.io, Airtable, Google Drive, ChatGPT, and Gemini, SmartHire combines AI-driven resume screening, dynamic job posting, smart candidate ranking, and advanced interview question generation to attract and secure top talent faster than ever. Built for modern HR teams, SmartHire empowers organizations to make data-driven hiring decisions and deliver a seamless candidate experience.`,
    techstack: "n8n, Bubble.io, Airtable, Google Drive, OpenAI GPT, Gemini, Slack, Gmail",
    previewLink: "/n8n/smarthire",
    githubLink: "https://github.com",
    id: "smarthire"
    
  },
  

  {
    title: "LeadFlow",
    image: projectImage26,
    description: "LeadFlow is an end-to-end AI-powered lead qualification and sales automation system built using n8n, ChatGPT, Airtable, Supabase, Jotform, and Gmail. It intelligently captures leads from multiple channels, dynamically generates personalized qualification forms using AI, evaluates responses to determine lead quality, and automatically assigns the right sales agent. This ensures higher conversion rates, efficient agent utilization, and seamless lead management.",
    techstack: "n8n, OpenAI GPT, Airtable, Supabase, Jotform, Gmail",
    previewLink: "/n8n/lead-flow",
    githubLink: "https://github.com",
    id: "lead-flow"
    
  },
  {
    title: "KnowledgeFlow",
    image: projectImage28,
    description: "KnowledgeFlow is an AI-powered document management and Q&A system that allows admins to create and manage knowledge documents stored in a vector database, and allows users to ask natural language questions based on that knowledge. Built using Bubble.io, n8n, Supabase Vector Store, and powered by ChatGPT and Gemini, this platform supports intelligent document understanding, upload, update, deletion, and retrieval workflows.",
    techstack: "n8n, Bubble.io, Supabase Vector Store,  OpenAI GPT, Gemini, Javascript",
    previewLink: "/n8n/knowledge-flow",
    githubLink: "https://github.com",
    id: "knowledge-flow"
    
  },



  {
    title: "Automating Daily Ticket Summaries with AI",
    image: projectImage34,
    description: "The client was overwhelmed by the constant need to stay updated on daily Jira tickets without having to read through every thread or log into the system manually. They wanted a simple way to keep track of ongoing support issues and engineering updates without wasting hours each day. I built the Daily Jira Ticket Summarizer, an AI-powered automation using n8n, Jira Software, and ChatGPT API. It collects newly created or updated tickets, gathers all related comments, summarizes the entire context using ChatGPT, and delivers a clean daily email digest directly to the client’s inbox, saving them time while keeping them fully informed.",
    techstack: "n8n, Jira, OpenAI GPT, Javascript",
    previewLink: "/n8n/automating-daily-ticket-summaries",
    githubLink: "https://github.com",
    id: "automating-daily-ticket-summaries"
    
  },
  {
    title: "Automating Jira Ticket Creation with AI",
    image: projectImage35,
    description: "Creating support issue tickets and feature request tickets across Slack and Jira quickly became time-consuming for the client. Conversations were getting lost, and valuable feedback wasn’t turning into action fast enough. To solve this, I created the Jira Ticket Generator, a smart, fully automated workflow built with n8n that transforms casual Slack messages into clean, categorized Jira tickets. Using the ChatGPT API, the system intelligently interprets each message and generates the appropriate ticket, either as a Bug or a Task, directly in Jira. If the request is valid, the bot responds in Slack with a direct link to the new ticket. If not, it replies with a clear explanation. The result is a streamlined, intelligent system that saves time.",
    techstack: "n8n, Jira, Slack, OpenAI GPT, Airtable",
    previewLink: "/n8n/jira-ticket-generator",
    githubLink: "https://github.com",
    id: "jira-ticket-generator"
    
  },



];


// Enter your Contact Details here
export const contactDetails = {
  email: "billychartanto@gmail.com",
  phone: "",
};
